import { useState, useEffect, useCallback } from 'react'
import {
  getLastViewedPid,
  getLastViewedPedigree,
  getTreeStartingPid,
  setLastViewedPedigree,
  setLastViewedPid,
} from '@fs/zion-tree-groups'

export const getPedigreeAndPid = async ({ treeId }) => {
  const lastViewedPedigree = await getLastViewedPedigree()
  const lastViewedPidAndTree = await getLastViewedPid('pedigree')
  const [lastPid, lastPidTreeId] = lastViewedPidAndTree?.split(':') || []
  const lastViewedPid = treeId === lastPidTreeId ? lastPid : null
  const view = lastViewedPedigree || 'portrait'

  const { personId: startingPid } = (await getTreeStartingPid(treeId || 'PRIVATE')) || {}
  const pid = lastViewedPid || startingPid || ''

  return { view, pid, startingPid }
}

export const usePedigreeData = ({ treeId, groupsLoading }) => {
  const [startingData, setStartingData] = useState({ loading: true })

  const updateLastView = useCallback((view) => {
    setLastViewedPedigree(view)
    setStartingData((prev) => ({ ...prev, lastView: view }))
  }, [])

  const updateLastPid = useCallback(
    (pid) => {
      setLastViewedPid(`${pid}:${treeId}`, 'pedigree')
      setStartingData((prev) => ({ ...prev, lastPid: pid }))
    },
    [treeId]
  )

  useEffect(() => {
    let mounted = true

    if (!groupsLoading) {
      // Get fallback values for pid and view if not contained in the URL
      getPedigreeAndPid({ treeId })
        .then(({ view, pid, startingPid }) => {
          return mounted && setStartingData({ lastView: view, lastPid: pid, startingPid, loading: false })
        })
        .catch(() => {})
    }

    return () => {
      mounted = false
    }
  }, [groupsLoading, treeId])
  return { ...startingData, updateLastView, updateLastPid }
}
